import { useTranslation } from '@/lib/i18n';
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui';

interface AdminAccountDeactivateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  accountName: string;
  onConfirm: () => void;
  busy?: boolean;
}

export const AdminAccountDeactivateDialog = ({
  open,
  onOpenChange,
  accountName,
  onConfirm,
  busy = false,
}: AdminAccountDeactivateDialogProps) => {
  const { t } = useTranslation('common');
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('admin.accounts.deactivate.title')}</DialogTitle>
          <DialogDescription>
            {t('admin.accounts.deactivate.desc', { name: accountName })}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="ghost" size="sm">
              {t('admin.common.cancel')}
            </Button>
          </DialogClose>
          <Button variant="danger" size="sm" disabled={busy} onClick={onConfirm}>
            {t('admin.accounts.actions.deactivate')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
